import React, {createContext, useEffect, useState, useContext} from 'react';
import Loader from "../loader/Loader";
import {EDIT_FMC_ROLE, VIEW_FMC_ROLE} from "../../Constants";
import {GlobalStateContext} from "../global/context/GlobalStateContext";
import {getTcpRoles, getUserLoginFromParent} from "../handler/ParentDataHandler";
import {NO_PERMISSION_ERROR} from "../util/RouteConstants";

export const PermissionsContext = createContext();

const PermissionsContextProvider = ({children}) => {
    const {setAsyncError} = useContext(GlobalStateContext);
    const [isAuthorised, setIsAuthorised] = useState(false);
    const [isEditor, setIsEditor] = useState(false);
    const [canEnableProgram, setCanEnableProgram] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        (async () => {
            const tcpRolesResponse = await getEmployeeTCPRoles();
            if(tcpRolesResponse.includes(VIEW_FMC_ROLE) || tcpRolesResponse.includes(EDIT_FMC_ROLE)) {
                setIsAuthorised(true);
                //Any user role now should able to enable program, program level access is controlled from backend
                setCanEnableProgram(true);
            } else {
                // this is temporary change. this logic should be shifted to backend
                setAsyncError(NO_PERMISSION_ERROR);
            }
            if(tcpRolesResponse.includes(EDIT_FMC_ROLE)) {
                setIsEditor(true);
            }
            setIsLoading(false);
        })();
    }, []);
    if(isLoading) return <Loader />;
    return <PermissionsContext.Provider value={{isAuthorised, isEditor, canEnableProgram}}>{children}</PermissionsContext.Provider>
}

export async function getEmployeeTCPRoles() {
    let response = await getTcpRoles();
    return JSON.parse(response.roles);
}

export async function getUserLogin() {
    const response = await  getUserLoginFromParent();
    let userAlias = response.name
    if (userAlias) {
        userAlias = userAlias.replace(/"/g, "");
    }
    return userAlias;
}

export default PermissionsContextProvider;


// WEBPACK FOOTER //
// ./src/components/permissions/PermissionContext.js